/**
 * Словник: nb.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_nb.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Venter på den andre deltakeren...",
  connectionLost: "Forbindelsen ble brutt",
  peerLeft: "👋 Den andre deltakeren forlot samtalen",
  connectionError: "🚫 Tilkoblingsfeil",
  connectionFailedTryAgain: "🚫 Kunne ikke koble til serveren. Prøv igjen.",
  reconnectionFailed: "🚫 Forbindelsen ble brutt. Kunne ikke gjenopprette den etter {attempts} forsøk.",
  connectionErrorWithDetails: "🚫 Tilkoblingsfeil: {error}",
  speakerLoud: "Høyt",
  speakerEar: "Øre",
  copyRoomId: "Kopier rom-ID",
  share: "Del",
  linkCopied: "🔗 Lenke kopiert!",
  idCopied: "🆔 ID kopiert!",
  startMeeting: "Start møte",
  chooseAction: "Velg en handling",
  createNewRoom: "Nytt rom",
  scheduleCall: "Planlegg samtale",
  calendarOpened: "📅 Kalenderen er åpnet",
  linkCopiedToClipboard: "🔗 Lenken er kopiert til utklippstavlen",
  enterRoomId: "Oppgi rom-ID",
  roomIdValidationError: "Rom-ID-en kan bare inneholde bokstaver, tall og bindestreker",
  joinRoom: "BLI MED",
  termsAndPrivacyHelp: "Vilkår og personvern | Hjelp",
  invite: "Inviter",
  mySettings: "Mine innstillinger",
  peerSettings: "Den andres innstillinger",
  blockRemoteControl: "Blokker fjernstyring",
  iAgreeToTerms: "Jeg godtar vilkårene for tjenesten",
  termsOfUse: "Bruksvilkår",
  privacyPolicy: "Personvernerklæring",
  howToUse: "Slik fungerer det",
  termsAcceptanceRequired: "Du må godta vilkårene for å bruke tjenesten",
  ok: "OK",
  permissionsRequired: "Tillatelser kreves",
  permissionsNeededMessage: "Appen trenger følgende tillatelser for å fungere som den skal:",
  permissionsNote: "Merk: Når du endrer tillatelser i Innstillinger, starter iOS appen på nytt. Dette er helt normalt.",
  permissionsEnableMessage: "Slå på disse tillatelsene i enhetsinnstillingene for å fortsette.",
  cancel: "Avbryt",
  openSettings: "Åpne innstillinger",
  websocketError: "WebSocket-feil",
  roomFull: "Rommet er fullt",
  timeExpired: "Tiden er ute",
  remaining: "igjen",
  mediaPermissionsRequired: "Videosamtaler krever tilgang til kamera og mikrofon. Gi tillatelse i nettleseren.",
  mediaPermissionsRequiredMobile: "Videosamtaler krever tilgang til kamera og mikrofon. Gi tillatelse i appinnstillingene.",
  browserSettings: "Nettleserinnstillinger",
  openAppSettings: "Åpne innstillinger",
  grantPermissions: "Gi tillatelse",
  permissionsNotGranted: "Tillatelse er ikke gitt. Gi tillatelse for å fortsette.",
  permissionRequestError: "Feil ved forespørsel om tillatelser: {error}",
  camera: "Kamera",
  microphone: "Mikrofon",
  cameraDescription: "For overføring av video",
  microphoneDescription: "For overføring av lyd",
  continueWithoutPermissions: "Fortsett uten tillatelser",
  mediaPermissionsRequiredFallback: "Videosamtaler krever medietillatelser. Gi tillatelse i nettleserinnstillingene.",
  mediaPermissionsRequiredMobileFallback: "Videosamtaler krever medietillatelser. Gi tillatelse i appinnstillingene.",
  browserSettingsFallback: "Nettleserinnstillinger",
  openAppSettingsFallback: "Åpne innstillinger",
  permissionsPermanentlyDenied: "Tillatelsene er avslått permanent. Slå dem på i appinnstillingene.",
  continueText: "Fortsett",
  mirror: "Speil",
  fitContain: "Tilpass",
  fitCover: "Fyll",
  switchCamera: "Snu",
  block: "Blokker",
  pip: "PiP",
  mic: "Mikrofon",
  video: "Video",
  speaker: "Høyttaler",
  readyToConnect: "Klar til å snakke?",
  startOneOnOne: "Start en videosamtale",
  createPrivateLink: "Lenken klar på et sekund",
  welcomeExplainer: "Lag en lenke og send den til hvem som helst. Den åpnes også uten appen.",
  joinHaveLink: "Har du en lenke?",
  joinFieldHint: "Lim inn lenke eller ID",
  roomInputInvalid: "Lim inn en samtalelenke eller en rom-ID (bokstaver, tall og bindestreker)",
  guestTitle: "Du er invitert til en videosamtale",
  guestBody: "Rommet er klart. Den andre ser deg så snart du blir med.",
  guestJoin: "Bli med",
  guestFreeNote: "Det er alltid gratis å bli med",
  guestCreateOwn: "Opprett mitt eget rom",
  guestInvalidTitle: "Lenken ser ut til å være ødelagt",
  guestInvalidBody: "Be om lenken på nytt, eller opprett ditt eget rom.",
  inviteCardTitle: "Rommet ditt er klart",
  inviteCardBody: "Send lenken til den du vil snakke med",
  inviteShareLink: "Del lenke",
  inviteCopy: "Kopier",
  inviteBrowserHint: "Åpnes i alle nettlesere. Du trenger ikke å installere appen.",
  inviteSentHint: "Sendt? Den andre dukker opp her så snart lenken åpnes.",
  inviteShareMessage: "Bli med i videosamtalen min på One2One 👋\nBare åpne lenken. Den virker i nettleseren, du trenger ikke installere noe:\n{link}",
  copyLink: "Kopier lenke",
  consentBannerText: "Får vi samle inn bruksstatistikk? Den viser oss hvilke funksjoner som brukes. Samtaleinnhold blir aldri tatt med.",
  consentAllow: "Tillat",
  consentDeny: "Ikke tillat",
  privacySettingsLink: "Statistikkinnstillinger",
} as const;
